import React from "react";
import styled from "styled-components";
import LayoutCatalog from "../../../components/layout/LayoutCatalog";
import ProductCard from "../../../components/сard/ProductCard";
import { product } from "../../../__generated__/product";
import { GET_PRODUCT } from "../../../queries/Products";
import getUndef from "../../../lib/get-undef";
import NotFoundPage from "../../ErrorPages/NotFoundPage";

const Item = ({ data, notFound }: { data: product; notFound?: boolean }) => {
  if (notFound) {
    return <NotFoundPage />;
  }

  return (
    <CustomLayoutCatalog>
      <Container>
        <ProductCard data={data} />
      </Container>
    </CustomLayoutCatalog>
  );
};

const CustomLayoutCatalog = styled(LayoutCatalog)`
  @media (max-width: 1050px) {
    width: 100%;
    margin-top: -55px;
  }

  @media (max-width: 980px) {
    width: 100%;
    margin-top: -45px;
  }
`;

const Container = styled.div`
  width: 100%;
  border-radius: 20px;
  background-color: #fff;
`;

Item.getInitialProps = async ({
  res,
  apolloClient,
  query: { code, item },
}: any) => {
  const { data }: { data: product } = await apolloClient.query({
    query: GET_PRODUCT,
    variables: {
      slugCollection: code,
      slugProduct: item,
    },
  });

  const product = getUndef(() => data.shop.collections[0].products[0]);

  if (!product || !product.active) {
    res.statusCode = 404;
    return {
      notFound: true,
    };
  }

  return { data };
};

export default Item;
